import { PageNames, SegmentSources, tealiumEventPageTypes } from '@foxcorp/delta-web-analytics';
import { getItemBadge } from 'helpers/VideoProcessorHelper';
import { getShowType, isCategoryTypePersonality } from 'helpers/ContentHelper';
import { onResultClick } from 'screens/Find/components/FindProcessor';

const SearchPosterProcessor = ({ account, isPersonality, item, searchProps }) => {
  const posterImage = item?.images?.['dcg-mark-poster']?.raw;
  const posterAltText = item?.images?.['dcg-mark-poster']?.altText ?? '';
  const id = item?.id;
  const link = isPersonality ? `/personalities/${id}` : `/${item?.showCode}`;
  const contentFlags = item?.contentFlags ?? [];
  const badge = contentFlags?.[0] ?? '';
  const name = item?.name ?? '';

  return {
    link,
    onPosterClick: () => onResultClick({ account, item, searchProps }),
    posterAltText,
    posterImage,
    badge,
    name,
  };
};

const WatchlistPosterProcessor = ({ item }) => {
  const posterImage = item?.images?.['dcg-mark-poster']?.raw;
  const posterAltText = item?.images?.['dcg-mark-poster']?.altText ?? '';
  const link = `/${item?.showCode}`;
  const id = item?.id;
  const type = item?.['@type'];
  const contentFlags = item?.contentFlags ?? [];
  const badge = contentFlags?.[0] ?? '';
  const name = item?.name ?? '';

  return {
    link,
    onPosterClick: () => {},
    posterAltText,
    posterImage,
    badge,
    name,
    overlayProps: {
      badge: getItemBadge(item),
      favoriteData: {
        actionLocation: 'playlist',
        favoritableItems: [{ '@type': type, id }],
        favoriteType: type,
        location: tealiumEventPageTypes?.[PageNames.HOME],
        networkId: item?.network,
        recommendationId: item?.trackingData?.properties.recommendationId ?? '',
        seriesName: item?.name,
        showID: item?.showCode,
        showType: getShowType({ videoType: item?.videoType, seriesType: item?.seriesType }),
        source: SegmentSources.DETAIL,
      },
    },
  };
};

const browsePosterProcessor = ({ account, item }) => {
  const posterImage = item?.images?.['dcg-mark-poster']?.raw;
  const posterAltText = item?.images?.['dcg-mark-poster']?.altText ?? '';
  const isPersonality = isCategoryTypePersonality(item?.categoryType);
  const id = item?.id;
  const link = isPersonality ? `/personalities/${id}` : `/${item?.showCode}`;
  const type = item?.['@type'];
  const contentFlags = item?.contentFlags ?? [];
  const badge = contentFlags?.[0] ?? '';
  const name = item?.name ?? '';
  const handleClick = () => {
    onResultClick({ item, titleText: name, account });
  };

  return {
    link,
    onPosterClick: handleClick,
    posterAltText,
    posterImage,
    badge,
    name,
    overlayProps: {
      badge: getItemBadge(item),
      favoriteData: {
        actionLocation: 'playlist',
        favoritableItems: [{ '@type': type, id }],
        favoriteType: 'personality',
        location: tealiumEventPageTypes?.[PageNames.HOME],
        networkId: item?.network,
        recommendationId: item?.trackingData?.properties.recommendationId ?? '',
        seriesName: item?.name,
        showID: item?.showCode,
        showType: getShowType({ videoType: item?.videoType, seriesType: item?.seriesType }),
        source: SegmentSources.DETAIL,
      },
    },
  };
};

export { SearchPosterProcessor, WatchlistPosterProcessor, browsePosterProcessor };
